import api from './axios';

export interface BackupEntry {
  id: string;
  source: 'tracked' | 'file';
  company_code: string | null;
  company_name: string | null;
  backup_type: string;
  file_name: string | null;
  size_bytes: number | null;
  created_at: string | null;
  downloadable: boolean;
}

export interface BackupsResponse {
  backups: BackupEntry[];
}

export const listBackups = (): Promise<{ data: BackupsResponse }> =>
  api.get('/super-admin/database/backups');

export const downloadBackup = async (fileName: string): Promise<void> => {
  const res = await api.get(`/super-admin/database/backups/download`, {
    params: { file: fileName },
    responseType: 'blob',
  });
  const href = URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement('a');
  a.href = href;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(href);
};
